"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideBarListItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../../hooks");
var _A = require("../../../../UI/A");
var _Icon = require("../../../../UI/Icon");
var _SideBar = _interopRequireDefault(require("../SideBar.styles"));
var _SideBar2 = require("../SideBar.labels");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SideBarListItem = itemProps => {
  const getLabel = (0, _hooks.useLabels)({
    labels: _SideBar2.labels
  });
  const {
    item,
    isMoreMenuItem = false,
    onItemClick,
    expandOnHover = false
  } = itemProps;
  const {
    id,
    label,
    isSelected,
    isNewItem,
    isMoreMenuItemOpen,
    withTopSeparator,
    href,
    target,
    icon,
    onClick,
    items
  } = item;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const hasItems = items && items.length > 0;
  const [isOpen, setIsOpen] = (0, _react.useState)(isMoreMenuItemOpen !== undefined ? isMoreMenuItemOpen : true);
  const styles = (0, _SideBar.default)(expandOnHover, !!isSelected, isOpen, isMoreMenuItem, withTopSeparator);
  const toggleMenu = e => {
    e.preventDefault();
    !isMobileView && setIsOpen(isOpen => !isOpen);
  };
  const handleOnClick = e => {
    if (hasItems) {
      toggleMenu(e);
    } else {
      onClick && onClick(e);
      onItemClick && onItemClick(e);
    }
  };
  const role = hasItems ? 'button' : undefined;
  const ariaControls = hasItems ? `cc-SideBar__menu__item__accordion-${id}` : undefined;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
    className: styles['cc-SideBar__menu__item'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
      isBtnView: true,
      view: "alternate",
      color: "basic",
      size: isMobileView ? 'small' : 'large',
      shape: isMobileView && !isMoreMenuItem ? 'rectangle' : 'roundedRectangle',
      onClick: e => handleOnClick(e),
      to: href ?? '',
      target: target,
      id: id,
      role: role,
      ariaControls: ariaControls,
      ariaExpanded: hasItems && isOpen || undefined,
      customStyle: styles['cc-SideBar__menu__item__anchor'](),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-SideBar__menu__item__anchor-content'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-SideBar__menu__item__icon'],
          children: icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: icon
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-SideBar__menu__item__label'],
          children: label
        }), isNewItem && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-SideBar__menu__item__new-item'],
          children: getLabel('newItemLabel')
        }), hasItems && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-SideBar__menu__item__arrow'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "ArrowSidebar"
          })
        })]
      })
    }), hasItems && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "region",
      id: ariaControls,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: styles['cc-SideBar__menu__item__inner-list'],
        children: items.map((item, i) => {
          const itemProps = {
            item,
            isMoreMenuItem,
            onItemClick
          };
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(SideBarListItem, {
            ...itemProps
          }, i);
        })
      }, `ul-${id}`)
    })]
  }, id);
};
exports.SideBarListItem = SideBarListItem;